import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Admin/Integration/WhatsappIntegration/WhatsappHome';

const WhatsappHome = () => ((orgContainer(InnerComponent)));
export default WhatsappHome;
